const currencyFormatter = new Intl.NumberFormat("pt-BR", {
  style: "currency",
  currency: "BRL",
  minimumFractionDigits: 2,
});

const percentFormatter = new Intl.NumberFormat("pt-BR", {
  minimumFractionDigits: 2,
  maximumFractionDigits: 2,
});

export type FormatCurrencyOptions = {
  prefix?: string;
  suffix?: string;
};

export const formatCurrency = (value: number, options: FormatCurrencyOptions = {}) => {
  const { prefix = "", suffix } = options;

  if (!Number.isFinite(value)) {
    return "-";
  }

  return `${prefix}${currencyFormatter.format(value)}${suffix ? ` ${suffix}` : ""}`;
};

export const formatPercent = (value: number) => {
  if (!Number.isFinite(value)) {
    return "-";
  }

  return `${percentFormatter.format(value)}%`;
};

export const parseNumber = (value: unknown): number | undefined => {
  if (typeof value === "number" && Number.isFinite(value)) {
    return value;
  }

  if (typeof value === "string" && value.trim() !== "") {
    const parsed = Number(value);
    return Number.isFinite(parsed) ? parsed : undefined;
  }

  return undefined;
};
